import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FeedbackForm from "./FeedbackForm";
import "./App.css";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Root URL */}
        <Route path="/" element={<FeedbackForm />} />

        {/* Dynamic URL - It will capture any value at the end */}
        <Route path="/:encodedId" element={<FeedbackForm />} />
      </Routes>
    </Router>
  );
};

export default App;